/**
 * Shared storefront order-tracking helpers: math captcha + proxy lookup.
 */
(function (window) {
  'use strict';

  var CHALLENGE_PATH = '/apps/scheduled-delivery/track-challenge';
  var TRACK_PATH = '/apps/scheduled-delivery/track';
  var LIMIT_NOTE =
    'Güvenlik için 15 dakikada en fazla 5 sipariş sorgulayabilirsiniz.';

  function fetchChallenge() {
    return fetch(CHALLENGE_PATH, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    }).then(function (res) {
      return res.json();
    });
  }

  function bindCaptcha(root) {
    if (!root) return null;
    var promptEl = root.querySelector('[data-bn-captcha-prompt]');
    var tokenEl = root.querySelector('[data-bn-captcha-token]');
    var answerEl = root.querySelector('[data-bn-captcha-answer]');
    var noteEl = root.querySelector('[data-bn-track-limit-note]');
    var refreshBtn = root.querySelector('[data-bn-captcha-refresh]');

    function setNote(text) {
      if (noteEl) noteEl.textContent = text || LIMIT_NOTE;
    }

    function load() {
      setNote(LIMIT_NOTE);
      if (answerEl) answerEl.value = '';
      if (tokenEl) tokenEl.value = '';
      if (promptEl) promptEl.textContent = '…';

      return fetchChallenge()
        .then(function (body) {
          if (!body || !body.ok) {
            if (promptEl) promptEl.textContent = '?';
            setNote(
              (body && body.message) ||
                'Güvenlik sorusu yüklenemedi. Lütfen yenileyin.',
            );
            return null;
          }
          if (promptEl) promptEl.textContent = body.prompt + ' = ?';
          if (tokenEl) tokenEl.value = body.token || '';
          setNote(body.limitNote || LIMIT_NOTE);
          return body;
        })
        .catch(function () {
          if (promptEl) promptEl.textContent = '?';
          setNote('Güvenlik sorusu yüklenemedi. Lütfen yenileyin.');
          return null;
        });
    }

    if (refreshBtn) {
      refreshBtn.addEventListener('click', function (e) {
        e.preventDefault();
        load();
      });
    }

    load();

    return {
      load: load,
      getValues: function () {
        return {
          token: tokenEl ? String(tokenEl.value || '').trim() : '',
          answer: answerEl ? String(answerEl.value || '').trim() : '',
        };
      },
    };
  }

  function trackLookup(params) {
    var order = params.order;
    var email = params.email;
    var captcha_token = params.captcha_token;
    var captcha_answer = params.captcha_answer;
    var proxy = params.proxy || TRACK_PATH;

    var url =
      proxy +
      (proxy.indexOf('?') >= 0 ? '&' : '?') +
      'order=' +
      encodeURIComponent(order) +
      '&email=' +
      encodeURIComponent(email) +
      '&captcha_token=' +
      encodeURIComponent(captcha_token) +
      '&captcha_answer=' +
      encodeURIComponent(captcha_answer);

    return fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    }).then(function (res) {
      return res.json().then(function (body) {
        return { status: res.status, body: body || {} };
      });
    });
  }

  window.BNOrderTrack = {
    LIMIT_NOTE: LIMIT_NOTE,
    fetchChallenge: fetchChallenge,
    bindCaptcha: bindCaptcha,
    trackLookup: trackLookup,
  };
})(window);
